import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import TiposPlataformaTable from './_TiposPlataformaTable.js';
import EditTipoPlataforma from './_EditTipoPlataforma.js';
const URI = ApiEndpoint + 'configuration/';

const TiposPlataforma = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tiposPlataforma, setTiposPlataforma] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [idTipoPlataformaEdit, setIdTipoPlataformaEdit] = useState(null);
  // const handleCloseConfirm = () => {
  //   setOpenConfirm(false);
  //   getTiposPlataforma();
  // };

  const handleClose = () => {
    console.log(openConfirm);

    setOpenModal(false);
    getTiposPlataforma();
  };

  const getTiposPlataforma = async () => {
    setTiposPlataforma(null);

    httpClient('GET', URI + 'tiposplataforma', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setTiposPlataforma(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getTiposPlataforma();
  }, []);
  return (
    <>
      {tiposPlataforma && (
        <TiposPlataformaTable
          tiposPlataforma={tiposPlataforma}
          setOpenModal={setOpenModal}
          setOpenConfirm={setOpenConfirm}
          setIdTipoPlataforma={setIdTipoPlataformaEdit}
        ></TiposPlataformaTable>
      )}
      {/* {openConfirm && (
        <ConfirmAction
          message={'Desea eliminar el registro?'}
          title={'Confirmacion'}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          ConfirmAction={DeleteConfirmed}
        ></ConfirmAction>
      )} */}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idTipoPlataformaEdit > 0 ? 'Editar' : 'Agregar') +
            ' Tipo de Plataforma'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditTipoPlataforma
            idTipoPlataforma={idTipoPlataformaEdit}
            closeModal={handleClose}
          ></EditTipoPlataforma>
        </MyModal>
      )}
    </>
  );
};

export default TiposPlataforma;
